import { FC, useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import { MdUploadFile } from 'react-icons/md';
import { Box, Flex, Icon, Text } from '@chakra-ui/react';

type DropzoneProps = {
  label?: string;
  name?: string;
  setFiles: (value: File[]) => void;
};

export const Dropzone: FC<DropzoneProps> = ({ label, name, setFiles }) => {
  const onDrop = useCallback(
    (acceptedFiles: File[]) => {
      if (acceptedFiles.length > 0) {
        setFiles(acceptedFiles);
      }
    },
    [setFiles],
  );

  const { getInputProps, getRootProps, isDragActive } = useDropzone({ onDrop });

  return (
    <Flex
      alignItems="center"
      bg="gray.25"
      borderStyle="dashed"
      borderWidth="1px"
      h={20}
      justifyContent="center"
      w="full"
      {...getRootProps()}
    >
      {/* the file input is the control the drop area stands for, so it takes
          the field's name as its id and the field's label as its own */}
      <input {...getInputProps({ 'aria-label': label, id: name })} />

      {isDragActive ? (
        <Text>Drop file(s) here</Text>
      ) : (
        <Flex alignItems="center">
          <Icon as={MdUploadFile} boxSize={12} mr={2.5} />

          <Box>
            <Text>Add file</Text>

            <Text color="gray.700" fontSize="sm">
              PDF accepted
            </Text>
          </Box>
        </Flex>
      )}
    </Flex>
  );
};
